import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/imprint")({
  staticData: { sitemap: true },
  head: () => ({
    meta: [
      { title: "Imprint — Foreign Council On Economic Relations" },
      {
        name: "description",
        content:
          "Imprint and legal information of the FCER Foundation e.V., including register details and the responsible board.",
      },
      { property: "og:title", content: "Imprint — Foreign Council On Economic Relations" },
      {
        property: "og:description",
        content: "Imprint and legal information of the FCER Foundation e.V., including register details and the responsible board.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://foreign-council.org/imprint" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://foreign-council.org/imprint" }],
  }),
  component: ImprintPage,
});

function ImprintPage() {
  return (
    <section className="bg-surface">
      <div className="mx-auto w-full max-w-[900px] px-5 py-16 lg:px-8 lg:py-20">
        <h1 className="fc-h2 fc-rule text-foreground">Imprint | Impressum</h1>

        <div className="mt-10 bg-card p-6 lg:p-10">
          <p className="fc-body font-bold text-foreground">
            Foreign Council On Economic Relations
          </p>
          <p className="mt-3 fc-body text-muted-foreground">
            Am Pergamonmuseum
            <br />
            Bauhofstraße 1
            <br />
            10117 Berlin
          </p>
          <p className="mt-5 fc-body text-muted-foreground">
            Phone: +49 30 692067500
            <br />
            Fax: + 49 30 692067509
            <br />
            E-Mail: reg @ foreign-council.org
            <br />
            Internet: www.foreign-council.org
          </p>
        </div>

        <h2 className="fc-h2 fc-rule mt-20 text-foreground">FCER Foundation e.V.</h2>

        <div className="mt-10 bg-card p-6 lg:p-10">
          <p className="fc-body font-bold text-foreground">FCER Foundation e.V.</p>
          <p className="mt-3 fc-body text-muted-foreground">Bauhofstraße 1 – 10117 Berlin</p>
          <p className="mt-5 fc-body text-muted-foreground">
            Country Court (Handelsregister) Berlin (Charlottenburg) | Register Nr.: 39452 B
          </p>
          <p className="mt-5 fc-body text-muted-foreground">
            Executive Board (Geschäftsleitung): Maximilian Hoffmann (President)
          </p>
          <p className="mt-5 fc-body text-muted-foreground">
            Phone (Telefon): +49 30 692067500
            <br />
            E-Mail: reg@foreign-council.org
          </p>
          <p className="mt-5 fc-body text-muted-foreground">
            Responsible for content (Inhaltlich verantwortlich): Maximilian Hoffmann
          </p>
        </div>
      </div>
    </section>
  );
}
